unit App.Session;

interface

uses
  WEBLib.Cookies,
  WEBLIB.Storage;

function GetVar(TokenName: string): string;
procedure SetVar(TokenName, Value: string);

implementation

function GetVar(TokenName: string): string;
var
  ls: TLocalStorage;
begin
  Result := '';
  ls := TLocalStorage.Create(nil);
  try
    Result := ls.GetValue(TokenName);
  finally
    ls.free;
  end;
end;

procedure SetVar(TokenName, Value: string);
var
  ls: TLocalStorage;
begin
//  ClearMyToken; // clear it first - not strictly necessary
  ls := TLocalStorage.Create(nil);
  try
    ls.SetValue(TokenName, Value);
  finally
    ls.free;
  end;
end;

end.
